var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":_vm.title,"back-to":`/admin/clients/${_vm.id}`}},[_c('v-container',{attrs:{"fluid":""}},[_c('ClientsForm',{ref:"form",staticClass:"mx-auto",attrs:{"width":"650","closeable":false},on:{"cancel":_vm.handleCancel,"submit":_vm.updateClient}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }